gsap.registerPlugin('ScrollTrigger');

gsap.defaults({ease: "none", duration: 8});

// create a sequence that moves 3 of the panels in from different directions
const tl = gsap.timeline({id: "panel-timeline"});
tl

// Two Section Function
.from(".panel-two", {
  opacity:0,
  delay: 2,
})

// Three Section Function
.from(".panel-three", {
  opacity:0,
  delay: 2,
})
.from(".panel-three .animateUp", {
  y:124,
  delay: 1,
})
.from(".panel-three .animateDown", {
  opacity:0
})

// Four Section Function
.from(".panel-four", {
  opacity:0,
  delay: 20,
})
.from(".panel-four .alshape", {
  scale: 0,
  // opacity:0,
  delay: 5,
})

// Five Section Function
.from(".panel-five", {
  opacity:0,
  delay: 20,
})
.from(".panel-five .animateUp", {
  y:85,
  delay: 0,
})
.from(".panel-five .animateDown", {
  opacity:0,
  y:-85,
  delay: 0,
})
.to(".panel-five .animateUp", {
  scale: 8,
  delay: 20,
})

// Six Section Function
.from(".panel-six", {
  opacity:0,
  delay: 10,
})
.from(".panel-six .w-logo", {
  y: -10,
  opacity:0,
  delay: 2,
  duration: 10,
})
.from(".panel-six .w-text", {
  scale: 2,
  xPercent: 0,
  opacity:0,
  delay: 30,
  duration: 5,
})
.from(".panel-six .textin-first", {
  y: 20,
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-six .textin-second", {
  x: 20,
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-six .textin-third", {
  x: -20,
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-six .textin-fourth", {
  y: -20,
  opacity:0,
  delay: 5,
  duration: 20,
})

// Seven Section Function
.from(".panel-seven", {
  opacity:0,
  delay: 15,
})
.from(".panel-seven .animateUp", {
  y:85,
  delay: 0,
})
.from(".panel-seven .animateDown", {
  opacity:0,
  y:-85,
  delay: 0,
})
.to(".panel-seven .animateUp", {
  scale: 8,
  delay: 20,
})

// Eight Section Function
.from(".panel-eight", {
  opacity:0,
  delay: 5,
})
.from(".panel-eight .w-logo", {
  y: -10,
  opacity:0,
  delay: 2,
  duration: 10,
})
.from(".panel-eight .textin-first", {
  y: 20,
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-eight .textin-second", {
  y: 20,
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-eight .textin-third", {
  y: -20,
  opacity:0,
  delay: 5,
  duration: 20,
})

// Nine Section Function
.from(".panel-nine", {
  opacity:0,
  delay: 50,
})
.from(".panel-nine .firstDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-nine .secondDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-nine .bar-1", {
  opacity: 0,
  y: 20,
  delay: 2,
})
.from(".panel-nine .bar-2", {
  opacity: 0,
  y: 20,
  delay: 2,
})
.from(".panel-nine .bar-3", {
  opacity: 0,
  y: 20,
  delay: 2,
})
.from(".panel-nine .bar-4", {
  opacity: 0,
  y: 20,
  delay: 2,
})
.from(".panel-nine .bar-5", {
  opacity: 0,
  y: 20,
  delay: 2,
})

// Ten Section Function
.from(".panel-ten", {
  opacity:0,
  delay: 15,
})
.from(".panel-ten .firstDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-ten .secondDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-ten .thirdDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-ten .fourthDown", {
  y: -20,
  opacity:0,
  delay: 5,
})

// Eleven Section Function
.from(".panel-eleven", {
  opacity:0,
  delay: 15,
})
.from(".panel-eleven .firstDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-eleven .secondDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-eleven .thirdDown", {
  y: -20,
  opacity:0,
  delay: 5,
})
.from(".panel-eleven .fourthDown", {
  y: -20,
  opacity:0,
  delay: 5,
})

// Twelve Section Function
.from(".panel-twelve", {
  y: 0,
  opacity:0,
  delay: 60,
})
.from(".panel-twelve .textin-first", {
  opacity:0,
  delay: 5,
  duration: 20,
})
.from(".panel-twelve .textin-second", {
  opacity:0,
  delay: 5,
  duration: 20,
})

// Thirteen Section Function
.from(".panel-thirteen", {
  opacity:0,
  delay: 0,
  y: 0,
  end: "bottom bottom+=300",
})

// Scrollcontainer Function
ScrollTrigger.create({
  animation: tl,
  trigger: ".scrollcontainer",
  start: "top top",
  end: "+=10000",
  scrub: true,
  pin: true, 
  pinSpacing: true,
  anticipatePin: 1,
});